/*
 * @Author: Teemo Ding
 * @Date: 2021-09-06 10:12:01
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-06 13:10:24
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/GiftPurchase/GiftPurchaseEdit/config.tsx
 */
import { NEW } from '@/src/tools/constant';
export const breadcrumbData = (
  salesChannelUuid,
  salesChannelName,
  flashSaleUuid,
  { getI18n },
) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/salesChannels',
    name: getI18n('general.sider.salesChannel'),
  },
  {
    url: `/${salesChannelUuid}`,
    name: salesChannelName,
  },
  {
    url: '',
    name: getI18n('general.discount'),
  },
  {
    url: `/salesChannel/discounts/giftPurchase/list/${salesChannelUuid}`,
    name: getI18n('general.sider.giftPurchase'),
  },
  {
    url: '',
    name:
      flashSaleUuid == NEW
        ? getI18n('salesChannelGiftPurchase.list.addGiftPurchase')
        : getI18n('salesChannelGiftPurchase.list.editGiftPurchase'),
  },
];
